import { useQuery } from '@tanstack/react-query';
import { InfoTip } from '@shared-ui/components';
import { siteVolumeApi } from '../../api/siteAnalyticsApi';

/**
 * The volume the window holds, across both sites, in one line under the
 * window picker — so a change of window shows how much is about to be
 * analysed before any report narrows it. Unaffected by any report's filters.
 * Absent until the backend serves it.
 */
export function VolumeLine({ from, to }: { from: Date; to: Date }) {
  const { data } = useQuery({
    queryKey: ['site-volume', from.toISOString(), to.toISOString()],
    queryFn: () => siteVolumeApi.get(from, to),
    retry: false,
  });
  if (!data) return null;
  const f = (v: number) => v.toLocaleString();
  return (
    <span className="sa-volume">
      <strong>{f(data.users)}</strong> users · <strong>{f(data.sessions)}</strong> sessions
      <InfoTip text={`Across both sites in this window, before any filter. Science site: ${f(data.bySite.science.users)} users, `
        + `${f(data.bySite.science.sessions)} sessions. App: ${f(data.bySite.app.users)} users, ${f(data.bySite.app.sessions)} sessions `
        + '— recorded only while session tracing is on, so fewer than use it. Teacher-app sessions are left out; '
        + 'a person on both sites is one user.'} />
    </span>
  );
}
